import Formatter from 'shared/utils/formatters'
import IMotorista from '../entities/IMotorista'
import IUpdateMotoristaRequest from '../entities/IUpdateMotoristaRequest'
import { IMotoristaRepository } from '../repositories/IMotoristaRepository'

export interface IUpdateMotorista {
  execute(params: IUpdateMotoristaRequest, id: number): Promise<IMotorista>
}

export default class UpdateMotoristaImpl implements IUpdateMotorista {
  constructor(private readonly motoristaRepository: IMotoristaRepository) {}
  async execute(
    { endereco, telefone, nome, email }: IUpdateMotoristaRequest,
    id: number,
  ): Promise<IMotorista> {
    return this.motoristaRepository.update(
      {
        telefone,
        endereco: {
          ...endereco,
          cep: endereco.cep.replace(Formatter.somenteNumeros(), ''),
        },
        nome,
        email,
      },
      id,
    )
  }
}
